(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6866],{

/***/ 52945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88077), __esModule: true };

/***/ }),

/***/ 88239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(52945);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 88077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(80529);
module.exports = __webpack_require__(94731).Object.assign;


/***/ }),

/***/ 50266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(95810);
var getKeys = __webpack_require__(99656);
var gOPS = __webpack_require__(32614);
var pIE = __webpack_require__(43416);
var toObject = __webpack_require__(19411);
var IObject = __webpack_require__(72312);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(93777)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 80529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(49901);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(50266) });


/***/ }),

/***/ 97387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 32321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDeviceId; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90257);
/* harmony import */ var _packages_justo_parts_lib_helpers_getQueryParam__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43621);
/* harmony import */ var _misc_generateId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6882);



function getDeviceId() {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()) return null;
    var paramDeviceId = (0,_packages_justo_parts_lib_helpers_getQueryParam__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("deviceId");
    if (paramDeviceId) {
        localStorage.setItem("deviceId", paramDeviceId);
        return paramDeviceId;
    }
    var savedId = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("deviceId");
    if (savedId) return savedId;
    var generatedId = (0,_misc_generateId__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(50);
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("deviceId", generatedId);
    return generatedId;
};


/***/ }),

/***/ 70457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96036);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67763);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_es__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_8__);




 // dependent on utc plugin




dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_2___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_7___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_8___default()));
// To detect the locale dynamically, we would need to add a babel-preset to
// allow dynamic imports, where in line 7 _es_ is a variable. For the time
// being I think it's better to leave it as it is, because there is still
// consideration towards going back to CRA as a bundler, and it doesn't allow a
// .babelrc config.
// I don't think differenciating between es locales makes sense, as this will
// be used to translate months, name of week days, etc.
dayjs__WEBPACK_IMPORTED_MODULE_0___default().locale("es");
/* harmony default export */ __webpack_exports__["Z"] = ((dayjs__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GenerateId; }
/* harmony export */ });
var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function GenerateId() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 24;
    var text = "";
    for(var i = 0; i < length; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};


/***/ }),

/***/ 90257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isServerSide; }
/* harmony export */ });
function isServerSide() {
    return "object" === "undefined";
};


/***/ }),

/***/ 11612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSessionStorageState; },
/* harmony export */   "z": function() { return /* binding */ getSavedValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_GlobalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91733);



var getSavedValue = function getSavedValue(key, defaultValue) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return defaultValue;
    var savedValue = sessionStorage.getItem(key);
    if (savedValue === null) {
        return defaultValue;
    } else {
        return JSON.parse(savedValue);
    }
};
function useSessionStorageState(key, defaultValue) {
    var value = getSavedValue(key, defaultValue);
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_GlobalState__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._);
    var setValue = function(newValue) {
        sessionStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return [
        value,
        setValue
    ];
};


/***/ }),

/***/ 91733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ Context; },
  "q": function() { return /* binding */ GlobalState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useForceUpdate.ts

var max = 9007199254740990;
function useForceUpdate() {
    var ref = (0,react.useState)(0), setState = ref[1];
    var forceUpdate = function() {
        return setState(function(state) {
            return (state + 1) % max;
        });
    };
    return forceUpdate;
};

;// CONCATENATED MODULE: ./src/providers/GlobalState.tsx



var Context = /*#__PURE__*/ react.createContext(null);
function GlobalState(props) {
    var forceUpdate = useForceUpdate();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: forceUpdate,
        children: props.children
    });
}



/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 84093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Root; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Provider/Message.js
var Message = __webpack_require__(36912);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js
var ApolloProvider = __webpack_require__(53768);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var lib = __webpack_require__(25074);
// EXTERNAL MODULE: ./src/providers/apollo/getClients.ts + 6 modules
var getClients = __webpack_require__(54599);
;// CONCATENATED MODULE: ./src/providers/apollo/ApolloServicesClients.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


 // Used inside AutoForm



function ApolloServicesClients(props) {
    var clients = (0,getClients/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.ApolloProvider, _objectSpread({}, clients, {
        client: clients.main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.ApolloProvider, {
            client: clients.main,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider/* ApolloProvider */.e, {
                client: clients.main,
                children: props.children
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/providers/GlobalState.tsx + 1 modules
var GlobalState = __webpack_require__(91733);
// EXTERNAL MODULE: ./src/providers/MobileOrDesktopContext.ts
var MobileOrDesktopContext = __webpack_require__(95078);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/useOnEvent.js
var useOnEvent = __webpack_require__(80967);
// EXTERNAL MODULE: ./src/helpers/auth/SessionContext.ts
var SessionContext = __webpack_require__(97387);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/providers/apollo/getJWTSavedData.ts

function getJWTSavedData() {
    if ((0,isServerSide/* default */.Z)()) return {};
    try {
        return JSON.parse(localStorage.getItem("justo_jwt_data")) || {};
    } catch (error) {
        return {};
    }
};

;// CONCATENATED MODULE: ./src/providers/Session.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function SessionContextProvider(props) {
    var jwtData = getJWTSavedData();
    var ref1 = (0,react.useState)(jwtData), session = ref1[0], setSession = ref1[1];
    (0,useOnEvent["default"])("saveSession", function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(newSession) {
            var ref, sendPosthogUserInfo, setPosthogUserId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSession(newSession);
                        if (!newSession) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 4;
                        return Promise.all(/* import() */[__webpack_require__.e(160), __webpack_require__.e(3023)]).then(__webpack_require__.bind(__webpack_require__, 53023));
                    case 4:
                        ref = _ctx.sent;
                        sendPosthogUserInfo = ref.sendPosthogUserInfo;
                        setPosthogUserId = ref.setPosthogUserId;
                        setPosthogUserId(newSession.userId);
                        sendPosthogUserInfo(newSession);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(newSession) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionContext/* default.Provider */.Z.Provider, {
        value: session || {},
        children: props.children
    });
};

// EXTERNAL MODULE: ./src/providers/WebsiteIdContext.ts
var WebsiteIdContext = __webpack_require__(70880);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/providers/locale.ts


__webpack_require__.g.numeral = (numeral_default());
__webpack_require__.g.dayjs = (dayjs_min_default());

;// CONCATENATED MODULE: ./src/providers/Root/index.tsx










var NonSsrRoot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3969).then(__webpack_require__.bind(__webpack_require__, 93969));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93969)
            ];
        }
    },
    ssr: false
});
function Root(param) {
    var children = param.children, pageProps = param.pageProps, websiteId = param.websiteId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalState/* GlobalState */.q, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktopContext/* default.Provider */.Z.Provider, {
            value: pageProps.mobileOrDesktop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteIdContext/* default.Provider */.Z.Provider, {
                value: websiteId,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message["default"], {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloServicesClients, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SessionContextProvider, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NonSsrRoot, {
                                    pageProps: pageProps
                                }),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var WebsiteIdContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
WebsiteIdContext.displayName = "WebsiteIdContext";
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteIdContext);


/***/ }),

/***/ 4266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getEnv; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);
/* provided dependency */ var process = __webpack_require__(34155);

var hostname = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() ? "" : window.location.hostname;
var isDev = hostname.includes("bejusto.com") || process.env.REACT_APP_DOMAIN;
var isLocal = hostname.endsWith(".local") || hostname.endsWith(".internal") || hostname.includes("localhost") || hostname.includes("100.1.20.187") || hostname.includes("192.168.") || hostname.includes(".ngrok.io") || hostname.includes("10.0.");
var isProduction = !isDev && !isLocal;
var forceProd = process.env.REACT_APP_FORCE_PRODUCTION;
function getEnv() {
    if (forceProd) return "prod";
    if (process.env.JUSTO_ENV) return process.env.JUSTO_ENV;
    if (isProduction) return "prod";
    return isDev ? "dev" : "local";
};


/***/ }),

/***/ 80967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(67294);
const store_1 = __webpack_require__(3496);
function useOnEvent(name, func, differs = null) {
    (0, react_1.useEffect)(() => {
        (0, store_1.addListener)(name, func);
        return () => {
            (0, store_1.removeListener)(name, func);
        };
    }, differs);
}
exports["default"] = useOnEvent;
//# sourceMappingURL=useOnEvent.js.map

/***/ })

}]);